import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import EditAccountsViewPage from "components/pages/EditAccountsViewPage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureAccountsEditAccounts(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    
    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <EditAccountsViewPage />
}